//noScroll
class MvSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    setTimeout(() => {
      const swiper = new Swiper(".swiper", {
        loop: true,
        effect: 'fade',
        speed: 2000,
        delay: 500,
        autoplay: true,
      });
    }, 2000);
  }
}